import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
position:relative;
width:100%;
height:100%;
left:0;
top:0;
bottom:0;
right:0;
`;

const Container = styled.div`
position:absolute;
left:50%;
transform-origin: left top;
width:${(props)=>props.w}px;
height:${(props)=>props.h}px;
top:0;
`;

function Resizing({ children, wh = { w: 1920, h: 1080 } }) {

    const container = useRef(null);

    function resize() {
        let ratio = window.innerWidth / window.innerHeight;
        let scale = window.innerWidth / wh.w;
        if (ratio > wh.w / wh.h) {
            scale = window.innerHeight / wh.h;
            if (scale < 0.3) {
                scale = 0.3;
            }
        } else {
            if (scale < 0.2) {
                scale = 0.2;
            }
        }
        container.current.style.transform = `scale(${scale}) translateX(-50%)`;
    }

    useEffect(() => {
        resize();
        window.onresize = resize;
    });

    return (
        <Wrapper>
            <Container ref={container} w={wh.w} h={wh.h}>
                {children}
            </Container>
        </Wrapper>
    );
}

export default Resizing;